import { useCallback } from 'react'

import { useAppDispatch } from '@/hooks'
import { tableRowSelected } from '@/store'

import { TableRowContent } from './TableRowContent'
import { TableSubRowContent } from './TableSubRowContent'
import { RowProps } from './types'

export const TableRowNoDnd = <Item extends object>({
	actionCellWidth,
	alwaysShowRowActions,
	hasLastRowEdit,
	hasLeftAction,
	isEditMode,
	isLastRow,
	isRowEditDisabled,
	onEdit,
	onDelete,
	hasRightAction,
	row,
	...rowProps
}: RowProps<Item>) => {
	const dispatch = useAppDispatch()

	const handleSelect = useCallback((selectedIndex: number) => {
		return dispatch(tableRowSelected(selectedIndex))
	}, [])

	return (
		<>
			<tr key={row.id} onClick={() => handleSelect(row.index)}>
				<TableRowContent
					actionCellWidth={actionCellWidth}
					alwaysShowRowActions={alwaysShowRowActions}
					hasLeftAction={hasLeftAction}
					hasLastRowEdit={hasLastRowEdit}
					isEditMode={isEditMode}
					isLastRow={isLastRow}
					isRowEditDisabled={isRowEditDisabled}
					onEdit={onEdit}
					onDelete={onDelete}
					row={row}
					hasRightAction={hasRightAction}
					{...rowProps}
				/>
			</tr>
			{row.getIsExpanded() && (
				<tr className="expandedRow">
					<td colSpan={6}>
						<TableSubRowContent row={row} />
					</td>
				</tr>
			)}
		</>
	)
}
